/**
 * PostHog analytics initialisation.
 *
 * PostHog is NOT initialised automatically on import. Call `initPostHog()`
 * after the user has given explicit cookie consent (PECR compliance).
 *
 * The default export (`posthog`) is re-exported for manual event capture in
 * hooks and components. If `initPostHog()` has not been called, all capture
 * calls are silent no-ops.
 */
import posthog from 'posthog-js';

let initialised = false;

/**
 * Initialise the PostHog SDK. Safe to call multiple times — subsequent calls
 * are ignored. Must only be called after the user has accepted analytics
 * cookies.
 */
export function initPostHog(): void {
  if (initialised) return;

  const key = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;
  if (!key) {
    if (import.meta.env.DEV) {
      console.warn('[PostHog] VITE_PUBLIC_POSTHOG_KEY is not set — analytics disabled.');
    }
    return;
  }

  posthog.init(key, {
    api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST || 'https://eu.i.posthog.com',
    autocapture: false,
    capture_pageview: true,
    capture_pageleave: true,
    loaded: (ph) => {
      if (import.meta.env.DEV) {
        console.info('[PostHog] Initialized. Distinct ID:', ph.get_distinct_id());
      }
    },
  });

  initialised = true;
}

export default posthog;
